document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-cart')) return;
  const form = document.querySelector('form[action="/cart"]');
  if (!form) return;

  const qtyInputs = form.querySelectorAll('input[name^="updates"]');

  const changeQty = async (input) => {
    // 取得此列的 line 編號（Dawn 常放在 data-index 或 data-line）
    const line = Number(input.dataset.index || input.dataset.line);
    const quantity = Number(input.value);

    // 若沒有 data-line，可回退用表單提交
    if (!line) {
      form.requestSubmit ? form.requestSubmit() : form.submit();
      return;
    }

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      location.reload(); // 簡單做法：更新後重新載入頁面
    } catch (e) {
      console.error(e);
      location.reload();
    }
  };

  const debounce = (fn, delay=250) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); };
  };

  qtyInputs.forEach(input => {
    input.addEventListener('change', debounce(() => changeQty(input)));
  });
});

